const reported = new Set<string>()

/** One line per model and path set for this browser session. */
export function reportDrift(
  model: string,
  unknown: readonly string[],
  degraded: boolean,
  error?: unknown
): void {
  if (unknown.length === 0 && !degraded) {
    return
  }

  const paths = [...unknown].sort().join(',')
  const key = `${model}|${degraded}|${paths}`
  if (reported.has(key)) {
    return
  }

  reported.add(key)
  const line = `FCDC drift model=${model} degraded=${degraded} unknown=${unknown.length} paths=${paths}`
  if (error !== undefined) {
    console.error(line, error)
    return
  }
  console.error(line)
}

export function resetDriftLog(): void {
  reported.clear()
}
